import styled from "styled-components"

const PageWrapper = styled.div`
  padding: 0 1rem 1rem;
  background-color: ${props => props.theme.color.lightBg};
`

export default PageWrapper
